<script lang="ts">
    import type { Snippet } from 'svelte';
    import { createApmErrorHandlerBrowser } from './createApmErrorHandler.browser.ts';

    type Props = {
        children: Snippet;
        failed?: Snippet<[error: unknown, reset: () => void]>;
        scope: string;
    };

    const { children, failed, scope }: Props = $props();

    /*                                     */
    const onerror = createApmErrorHandlerBrowser(scope);
</script>

<svelte:boundary {onerror} {failed}>{@render children()}</svelte:boundary>
